import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import "./theme/tokens.css";
import "./index.css";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { initAppPreloader } from './utils/appPreloader';
import { startThemeSync } from './services/theme';
import { getPreferredLanguage, loadPreferredLanguage } from './i18n';

startThemeSync();

function AppRoot() {
  useEffect(() => {
    initAppPreloader();
  }, []);

  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      {googleClientId ? (
        <GoogleOAuthProvider clientId={googleClientId}>
          <App />
        </GoogleOAuthProvider>
      ) : (
        <App />
      )}
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
// R9: when Urdu is remembered, load its catalog (small lazy chunk) before the first
// render so the page never flashes English. English renders straight away.
if (getPreferredLanguage() === 'en') {
  root.render(<AppRoot />);
} else {
  loadPreferredLanguage().finally(() => root.render(<AppRoot />));
}
